import { useState } from "react";
import { View, Text } from "react-native";
import { ErrorHelperText } from "../../components";
import { MaskedTextInput } from "../../components/styled";
import { colors } from "../../../theme";
import { FormData } from "./types";
import { FieldError } from "react-hook-form";

interface DateInputProps {
  label: string;
  name: keyof FormData;
  value: string;
  onChange: () => void;
  onBlur: () => void;
  error?: FieldError;
  disabled?: boolean;
}

export default function DateInput({ label, onChange, value, error, onBlur, disabled = false }: DateInputProps) {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => setIsFocused(!disabled);
  const handleBlur = () => {
    setIsFocused(false);
    onBlur();
  };

  const labelClassName = error?.message ? "text-red-darkest" : isFocused ? "text-primary" : "text-ink-light";
  const inputBorderClassName = error?.message ? "border-red-darkest" : isFocused ? "border-primary" : "border-sky-dark";

  const wrapperClassName = disabled ? "relative bg-sky-lighter justify-center rounded-lg py-2 px-4 h-12" : "relative";

  const inputLabelClassName = disabled ? "text-tiny" : "absolute left-2 -top-1.5 bg-white px-1";

  const inputClassName = disabled
    ? `${inputBorderClassName} bg-sky-lighter text-ink-lighter`
    : `h-12 py-3 pl-3 text-ink-darkest rounded-lg border ${inputBorderClassName}`;

  return (
    <View className={wrapperClassName}>
      <Text className={`text-tiny ${labelClassName} ${inputLabelClassName}`}>{label}</Text>
      <MaskedTextInput
        mask="99/99/9999"
        editable={!disabled}
        value={value}
        onChangeText={onChange}
        keyboardType="numeric"
        placeholder="MM/DD/YYYY"
        onBlur={handleBlur}
        onFocus={handleFocus}
        placeholderTextColor={colors.ink.lighter}
        className={`text-regular ${inputClassName}`}
        testID="date-input"
      />
      {error?.message && <ErrorHelperText error={error}>{error.message}</ErrorHelperText>}
    </View>
  );
}
